import { api } from './client'
import type { AcceptInviteResponse, PublicInviteResponse } from './types'

export const invitesApi = {
  get: (uuid: string) =>
    api.get<PublicInviteResponse>(`/public/invites/${uuid}`),

  accept: (uuid: string) =>
    api.post<AcceptInviteResponse>(`/public/invites/${uuid}`),
}
